var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantages5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4167 81.6667L59.0417 67.1667C63.125 64.1667 65.9583 59.5 66.5417 54.1667H83.3333C82.9893 59.6696 81.3727 65.0175 78.6107 69.7894C75.8487 74.5614 72.0168 78.6272 67.4167 81.6667ZM54.1667 29.2917V12.5C72.0833 13.5833 86.4167 27.9167 87.5 45.8333H70.7083C70.2415 41.6066 68.3487 37.6651 65.3418 34.6582C62.3349 31.6513 58.3934 29.7585 54.1667 29.2917ZM29.1667 52.0833C29.1667 54.75 29.7083 57.2917 30.75 59.5833L16.25 67.9583C13.7671 63.0359 12.4822 57.5965 12.5 52.0833C12.5 33.2083 27.25 17.7917 45.8333 16.6667V33.4583C36.4583 34.5 29.1667 42.4167 29.1667 52.0833ZM47.9167 87.5C35.5417 87.5 24.6667 81.25 18.3333 71.5833L32.8333 63.2083C34.5681 65.5786 36.8389 67.505 39.4603 68.8302C42.0817 70.1554 44.9794 70.8418 47.9167 70.8333C50.5833 70.8333 53.125 70.2917 55.4167 69.25L63.7917 83.75C59 86.1667 53.625 87.5 47.9167 87.5Z",
    fill: "url(#paint0_linear_231_965)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_965",
    x1: 6.5672,
    y1: 95.4172,
    x2: 87.4143,
    y2: 9.08672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0398851,
    stopColor: "#31D054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F64E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages5);
export default __webpack_public_path__ + "static/media/advantages_5.f5d77061c8980395dc06167486db91fd.svg";
export { ForwardRef as ReactComponent };